const SignupFormSchema = {
  type: "object",
  properties: {
    email: {
      type: "string",
      title: "Email",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    password: {
      type: "string",
      title: "Password",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Password",
    },
    first_name: {
      type: "string",
      title: "First Name",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    last_name: {
      type: "string",
      title: "Last Name",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
  },
};

export default SignupFormSchema;
